import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ConfigurationItemDetails, ConfigurationRequest} from '@app/model/configuration.model';
import {ConfigurationService} from '@app/service/configuration.service';
import {AlertService} from '@app/shared/service/alert.service';
import {ArticleView} from '@app/model/article-view.model';
import {FormControl, Validators} from '@angular/forms';

@Injectable({
	providedIn: 'root'
})
export class ShoppingCartService {
	#articleList$ = new BehaviorSubject<ShoppingCartItem[]>([]);

	// eslint-disable-next-line @typescript-eslint/member-ordering
	readonly articleList$ = this.#articleList$.asObservable();

	constructor(
		private configurationService: ConfigurationService,
		private alertService: AlertService) {
	}

	addConfigurationItemsToCart(newArticleList: ConfigurationItemDetails[]): void {
		const currentArticleList = this.#articleList$.value;

		newArticleList.forEach(item => {
			const existingConfigurationItem = currentArticleList.find(c => c.article.articleNumber === item.article.articleNumber);

			if (existingConfigurationItem) {
				const currentQuantity = existingConfigurationItem.quantity.value;
				existingConfigurationItem.quantity.setValue(currentQuantity + 1);
				this.alertService.alertInfo($localize`Anzahl von Artikel ${item.article.articleNumber} aktualisiert`);
			} else {
				currentArticleList.push({
					article: item.article,
					quantity: new FormControl(item.quantity, {nonNullable: true, validators: [Validators.min(1)]})
				});
				this.alertService.alertInfo($localize`Artikel ${item.article.articleNumber} hinzugefügt`);
			}
		});
		this.#articleList$.next(currentArticleList);
	}

	removeConfigurationItem(articleNumber: string): void {
		const currentConfiguration = this.#articleList$.value;
		const i = currentConfiguration.findIndex(c => c.article.articleNumber === articleNumber);
		if (i !== -1) {
			currentConfiguration.splice(i, 1);
		}
		this.alertService.alertInfo($localize`Artikel ${articleNumber} entfernt`);
		this.#articleList$.next(currentConfiguration);
	}

	resetConfiguration(): void {
		this.#articleList$.next([]);
	}

	saveArticleList(request: ConfigurationRequest): Observable<void> {
		return this.configurationService.saveConfiguration(request);
	}
}

export interface ShoppingCartItem {
	article: ArticleView;
	quantity: FormControl<number>;
}
